module.exports = __webpack_public_path__ + "static/BungeeInline-Regular-cbce6d7deb8053c358e6abcccf35410e.woff";